import { Link } from "react-router-dom";

import specialiste2 from "../assets/image.png";
import Waveform from "../components/Waveform";

const features = [
  {
    icon: "bi-arrow-left-right",
    title: "Vos numéros, conservés",
    text: "Transfert de vos numéros actuels vers la téléphonie IP sans interruption de service pour vos clients.",
  },
  {
    icon: "bi-diagram-3",
    title: "Standard automatisé (IVR)",
    text: "Menus personnalisés, files d'attente et transferts intelligents adaptés à votre organisation.",
  },
  {
    icon: "bi-phone",
    title: "Mobilité totale",
    text: "Application mobile et de bureau disponibles : vos équipes répondent depuis le bureau, à la maison ou en déplacement.",
  },
];

const steps = [
  {
    n: "01",
    title: "Analyse de vos besoins",
    text: "On évalue votre infrastructure, vos lignes actuelles et la façon dont vos équipes communiquent.",
  },
  {
    n: "02",
    title: "Configuration sur mesure",
    text: "Postes, numéros, menus et files d'attente sont configurés selon votre organisation.",
  },
  {
    n: "03",
    title: "Migration sans interruption",
    text: "Vos numéros existants sont transférés sans coupure de service pour vos clients.",
  },
  {
    n: "04",
    title: "Formation et accompagnement",
    text: "Vos équipes sont formées sur les outils, et notre support reste disponible en continu.",
  },
];

const techs = [
  {
    icon: "bi-router",
    name: "GDSM",
    text: "La technologie qui gère vos appels, vos files d'attente et vos menus de façon fiable et flexible.",
  },
  {
    icon: "bi-diagram-3-fill",
    name: "Axio",
    text: "Notre plateforme de gestion d'appels, pour configurer et superviser votre standard téléphonique au quotidien.",
  },
  {
    icon: "bi-telephone-fill",
    name: "Grandstream",
    text: "Des téléphones IP fiables et abordables, avec Wi-Fi et Bluetooth intégrés selon le modèle.",
  },
  {
    icon: "bi-toggles",
    name: "Cloud ou sur place",
    text: "Votre centrale IP peut être hébergée dans le cloud ou sur un boîtier local chez vous — les deux options sont disponibles selon votre besoin.",
  },
];

const otherServices = [
  {
    to: "/telephonie-ip/sms",
    icon: "bi-chat-dots-fill",
    title: "Textos pour entreprise",
    text: "Envoyez et recevez des textos depuis votre numéro professionnel existant.",
  },
  {
    to: "/telephonie-ip/fax",
    icon: "bi-printer-fill",
    title: "Fax par internet",
    text: "Recevez vos fax par courriel et envoyez-en sans avoir besoin d'un télécopieur.",
  },
  {
    to: "/telephonie-ip/equipements",
    icon: "bi-telephone-fill",
    title: "Équipements",
    text: "Des téléphones IP haut de gamme, à l'achat ou en location flexible.",
  },
];

export default function TelephonieIP() {
  return (
    <>
      {/* BANNIÈRE OFFRE — masquée pour le moment, à réactiver avec la page Offres */}
      {false && (
        <div className="bg-brand text-center py-2" data-aos="fade-down">
          <Link
            to="/offres"
            className="fw-bold text-decoration-none small"
            style={{ color: "#fff" }}
          >
            <i className="bi bi-stars me-2"></i>
            Offre en cours : migration gratuite + 1 mois offert sur la
            téléphonie IP
            <i className="bi bi-arrow-right ms-2"></i>
          </Link>
        </div>
      )}

      {/* HERO */}
      <section className="hero-section section">
        <div className="hero-blob" />
        <div className="container position-relative">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6" data-aos="fade-right">
              <span className="eyebrow">Téléphonie d'affaire</span>
              <h1 className="fw-900 mt-3 display-5">Téléphonie IP</h1>
              <p className="lead text-secondary mt-3">
                On prend en charge l’analyse, la configuration et la migration
                de votre système téléphonique vers une solution IP performante.
                Ainsi, votre équipe demeure facilement joignable et vos
                opérations se poursuivent sans interruption, tout en profitant
                d’un guichet unique pour l’ensemble de votre informatique.
              </p>

              <div className="hero-btns mt-4">
                <div className="price-pill">
                  À partir de <strong>15,00&nbsp;$</strong> / mois par poste
                </div>
                <Link
                  to="/transfert-telephone"
                  className="btn btn-brand btn-lg rounded-pill px-4"
                >
                  Transférer mon numéro
                </Link>
              </div>
              {/* NOTE FRAIS */}
              <p
                className="text-secondary mt-3 mb-0"
                style={{ fontSize: "0.85rem" }}
              >
                <i className="bi bi-info-circle me-1 text-brand"></i>
                Des frais de configuration et d'installation peuvent s'appliquer
                lors de la mise en place du service.
              </p>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <div className="call-card p-4 float-card">
                <div className="d-flex justify-content-between align-items-center pb-3 border-bottom">
                  <span className="font-mono small text-secondary">
                    APPAREIL INSTALLÉ EN CLINIQUE
                  </span>
                  <span className="pulse-dot"></span>
                </div>
                <div className="section-img mt-3 mb-3">
                  <img
                    src={specialiste2}
                    alt="Téléphone IP fixé au mur dans une clinique"
                  />
                </div>
                <Waveform height={36} />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TECHNOLOGIES 
      <section className="section pt-0">
        <div className="container">
          <span className="eyebrow" data-aos="fade-up">
            Sous le capot
          </span>
          <h2 className="fw-900 mt-3" data-aos="fade-up">
            Des technologies reconnues, bien assemblées
          </h2>
          <p
            className="text-secondary mt-3"
            style={{ maxWidth: "720px" }}
            data-aos="fade-up"
          >
            On ne réinvente pas la roue : on s'appuie sur des technologies
            solides et largement utilisées dans l'industrie, qu'on configure et
            qu'on entretient pour vous.
          </p>

          <div className="row g-4 mt-3">
            {techs.map((t, i) => (
              <div
                className="col-md-6 col-lg-3"
                key={t.name}
                data-aos="fade-up"
                data-aos-delay={i * 100}
              >
                <div className="service-card p-4 h-100">
                  <div className="service-icon mb-3">
                    <i className={`bi ${t.icon}`}></i>
                  </div>
                  <h3 className="h6 fw-bold">{t.name}</h3>
                  <p className="text-secondary small mb-0">{t.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>*/}

      {/* AVANTAGES */}
      <section className="section bg-cream">
        <div className="container">
          <div className="row">
            <div className="col-lg-7" data-aos="fade-up">
              <span className="eyebrow">Avantages</span>
              <h2 className="fw-900 mt-3">
                Tout ce qu'il faut, rien de compliqué
              </h2>
            </div>
          </div>

          <div className="row g-4 mt-3">
            {features.map((f, i) => (
              <div
                className="col-md-6 col-lg-4"
                key={f.title}
                data-aos="fade-up"
                data-aos-delay={(i % 3) * 100}
              >
                <div className="service-card p-4">
                  <div className="service-icon mb-3">
                    <i className={`bi ${f.icon}`}></i>
                  </div>
                  <h3 className="h6 fw-bold">{f.title}</h3>
                  <p className="text-secondary small mb-0">{f.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* COMMENT ÇA FONCTIONNE */}
      <section className="section">
        <div className="container">
          <span className="eyebrow" data-aos="fade-up">
            Notre approche
          </span>
          <h2 className="fw-900 mt-3" data-aos="fade-up">
            Le passage à la téléphonie IP, étape par étape
          </h2>

          <div className="row g-4 mt-3">
            {steps.map((s, i) => (
              <div
                className="col-md-6 col-lg-3"
                key={s.n}
                data-aos="fade-up"
                data-aos-delay={i * 100}
              >
                <div
                  className="h-100 ps-3"
                  style={{
                    borderLeft: `3px solid ${i === 0 ? "var(--cpuc-red)" : "var(--cpuc-border)"}`,
                  }}
                >
                  <span className="font-mono text-brand">{s.n}</span>
                  <h3 className="h6 fw-bold mt-2">{s.title}</h3>
                  <p className="text-secondary small mb-0">{s.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* AUTRES SERVICES TÉLÉPHONIE */}
      <section className="section bg-cream">
        <div className="container">
          <span className="eyebrow" data-aos="fade-up">
            Et ce n'est pas tout
          </span>
          <h2 className="fw-900 mt-3" data-aos="fade-up">
            Des options adaptées à chaque besoin de communication
          </h2>
          <div className="row g-4 mt-3">
            {otherServices.map((s, i) => (
              <div
                className="col-md-4"
                key={s.to}
                data-aos="fade-up"
                data-aos-delay={i * 100}
              >
                <Link
                  to={s.to}
                  className="service-card p-4 h-100 d-block text-decoration-none"
                >
                  <div className="service-icon mb-3">
                    <i className={`bi ${s.icon}`}></i>
                  </div>
                  <h3
                    className="h6 fw-bold"
                    style={{ color: "var(--cpuc-black)" }}
                  >
                    {s.title}
                  </h3>
                  <p className="text-secondary small mb-2">{s.text}</p>
                  <span className="fw-bold small text-brand">
                    En savoir plus <i className="bi bi-arrow-right ms-1"></i>
                  </span>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section pt-0">
        <div className="container">
          <div
            className="quote-block p-4 p-md-5 text-center"
            data-aos="zoom-in"
          >
            <h2 className="fw-900 mb-3" style={{ color: "#fff" }}>
              Prêt à simplifier votre téléphonie?
            </h2>
            <Link
              to="/transfert-telephone"
              className="btn btn-lg rounded-pill px-4"
              style={{
                background: "#fff",
                color: "var(--cpuc-red)",
                fontWeight: 700,
              }}
            >
              Demander un transfert de numéro
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
